import { graphql, useStaticQuery } from "gatsby";
    import { PatstoreLocation } from '@types';

const useGetLocation = () => {
    const data = useStaticQuery(graphql`
        query AllLocation {
            allPatstoreLocation {
                edges {
                    node {
                        id
                        
            objectId
    categories
    label
    title
    createdAt
    text
    gallery
    date
    state
    
                    }
                }
            }
        }
    
        `);


    const allLocation: PatstoreLocation[] =
        data.allPatstoreLocation.edges.map(
            (edge: { node: PatstoreLocation }) => edge.node
        ) || [];

    const findLocation: (id: string) => PatstoreLocation | undefined = (id: string) => {
        const result = allLocation.find((item: PatstoreLocation) => item.objectId === id);

        if (!result) {
            return undefined;
        }

        return result;
    };

    return {
        findLocation,
        locations: allLocation,
    };
}; 

export default useGetLocation;
